<div class="progress-outer">
    @if (progressType() === 'percentage') {
        <div
            class="progress-inner"
            [style.background-color]="color()"
            [style.width]="progress() + '%'"
            [style.padding]="progress() === 0 ? 0 : 10"
        >
            {{ name() }} {{ progress() }}%
        </div>
    }
    @if (progressType() === 'absolute') {
        <div
            class="progress-inner"
            [style.background-color]="color()"
            [style.width]="progress() + '%'"
            [style.padding]="progress() === 0 ? 0 : 10"
        ></div>
        <span class="absolute-label">
            <span ellipsisWithTitleFallback>{{ name() }} {{ current() }} / {{ maximum() }}</span>
        </span>
    }
</div>
